import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  animalHeader: {
    display: 'block',
    width: '100%',
    alignItems: 'center',

    '@media (min-width:356px)': {
      display: 'inline-flex'
    }
  },

  animalHeaderContent: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'start'
    }
  },

  animalHeaderBtnContainer: {
    display: 'flex',
    marginLeft: 8,
    gap: 10,

    [theme.breakpoints.down('sm')]: {
      padding: '16px 0',
      flexWrap: 'wrap',
      width: '100%',
      flexDirection: 'column-reverse'
    }
  },

  animalHeaderBtn: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    backgroundColor: 'transparent',
    width: 118,
    height: 40,
    borderWidth: 1,
    borderRadius: 6,
    borderColor: theme.palette.primary.main,
    fontWeight: 700,
    color: theme.palette.primary.main,

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  buttonWrapper: {
    width: 'max-content',
    display: 'flex',
    padding: '8px 16px 8px 12px',
    gap: '8px',
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  buttonOutlined: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },

  cardListContiner: {},
  loadMoreContainer: {
    paddingTop: 30,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}))
